import { styled } from '@withjoy/joykit';

export const Left = styled.div`
  display: flex;
  align-items: center;
`;
export const Spacer = styled.div`
  width: 24px;
  margin: 0;
  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    margin: 0 16px;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  position: relative;
  z-index: 200;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    margin: 0 16px;
  }
  > svg {
    margin: 0;
    @media (min-width: ${props => props.theme.breakpoints.sm}) {
      margin: 0 16px;
    }
  }
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;
